import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Container from 'components/Auth/Shared/Container';
import Button from 'uikit/Button';

import styles from './Logout.module.scss';

const cx = classNames.bind(styles);

const Logout = ({ t }) => (
  <Container>
    <div className={cx('container')}>
      <div className={cx('content')}>
        <h1 className={cx('title')}>{t('Auth/Logout/title')}</h1>
        <Button as={Link} intent="primary" size="large" to="/auth/login">
          {t('Auth/Logout/continue')}
        </Button>
      </div>
    </div>
  </Container>
);

Logout.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Logout;
